import { ActionProps, WrapperAction } from '../ActionIcon';
import { EditOutlined } from '@vindr/icons';

const Edit = ({ onClick, disabled, title, tooltip, ...props }: ActionProps) => {
  return (
    <WrapperAction {...{ onClick, disabled, title, ...props }} title={tooltip || 'Edit'}>
      <EditOutlined />
    </WrapperAction>
  );
};

export default Edit;
